const value = {
    systems: 'Системы',
    skillsMap: 'Карта компетенций',
    unitSearch: 'Поиск контекста, юнита',
    showUnits: 'Показывать юниты',
    unitsFilter: {
      all: 'Все',
      important: 'Обязательные',
      unimportant: 'Необязательные',
    },
    noUnits: 'Нет юнитов',
  };

export default value;
